import MaxWidth1200Layout from "@/components/Layout/MaxWidth1200Layout";
import Gray50Skeleton from "@/components/SkeletonLoader/Gray50Skeleton";
import { Box, SkeletonCircle } from "@chakra-ui/react";
// import dayjs from "dayjs";
import {
  Button,
  call,
  colors,
  customEvent,
  HStack,
  Link,
  setVisitedFeature,
  Spacing,
  // TablePagination,
  // TopBanner,
  useResponsive,
  VLine,
  VStack,
} from "goi_common";

import { useEffect } from "react";
import { ReviewSmallCarousel } from "./components/ReviewSmallCarousel/ReviewSmallCarousel";
import { ReviewTagButtonChip } from "./components/ReviewTag/ReviewTagButtonChip";
// import { ReviewTagChip } from "./components/ReviewTag/ReviewTagChip";

import PrepaidBanners from "@/components/common/PrepaidBanners";
// import { StarScore } from "../MatchContainer/components/MatchRecommendations/StarScore";
import { SANGJO_REVIEW_TAGS } from "./constants/reviewTags";
import { useReviewListByTag } from "./hooks/useReviewListByTag";
import { useReviewPageRouter } from "./hooks/useReviewPageRouter";
import { ReviewCard } from "../MatcRecommendationContainer/components/MatchRecommendationParlorAndFacilitySection";
// import { bestGoiReviews } from "../MatcRecommendationContainer/constants/bestGoiReviews";
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll";
import { useInifiniteDatas } from "@/hooks/useInfiniteDatas";

function ReviewContainer() {
  const {
    router,
    tag,
    page,
    // setReviewPageNum
  } = useReviewPageRouter();
  const pageNum = page ? Number(page) : 1;

  const {
    data: reviewsPages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useReviewListByTag({ page: pageNum, tag });
  const { datas: reviews } = useInifiniteDatas(reviewsPages);

  const { setTarget: setReviewTarget } = useInfiniteScroll(fetchNextPage);

  useEffect(() => {
    setVisitedFeature("review");
  }, []);

  const { isBiggerThanMd } = useResponsive();

  return (
    <MaxWidth1200Layout>
      <VStack alignItems="center" padding={isBiggerThanMd ? "60px 0 40px" : "40px 0 30px"} gap={24}>
        <Box className={isBiggerThanMd ? "head_32_b" : "subtitle_21_b"}>
          <h2>고이 이용 후기</h2>
        </Box>

        <HStack gap={8}>
          <Button
            css={{
              padding: isBiggerThanMd ? "15px 20px" : "10px 12px",
              background: colors.orange650,
              color: colors.white,
              borderRadius: "5px",
            }}
            className="button_14_sb"
            onClick={() => {
              customEvent({
                newGtm: { path: "review", trigger_and_target: "rqst_btn-uv_mtch_rqst" },
              });
              router.push("/match/request/");
            }}
          >
            견적 받기
          </Button>
          <Button
            css={{
              padding: isBiggerThanMd ? "15px 20px" : "10px 12px",
              background: colors.gray900,
              color: colors.white,
              borderRadius: "5px",
            }}
            className="button_14_sb"
            onClick={() => {
              customEvent({
                newGtm: { path: "review", trigger_and_target: "call_btn-call" },
              });
              call("1666-9784");
            }}
          >
            전화 상담
          </Button>
        </HStack>
        <ReviewSmallCarousel
          event={{
            path: "review",
            trigger_and_target: "review_section_review_detail-uv_review_detail",
          }}
        />
      </VStack>
      <PrepaidBanners eventPath="review" isMobile />
      <ReviewFilter />

      {/* <VStack padding="0px 24px" width="100%" gap={4}>
        {reviews ? (
          <>
            <VLine width="100%" height="2px" color={colors.gray300} />
            <BoardObjectTable
              boardPath="review"
              eventName={{
                newGtm: { path: "review", trigger_and_target: "review-uv_review_detail" },
              }}
              expandTableRow={(i) => {
                const tags = reviews.results[i].tags?.filter((t) => SANGJO_REVIEW_TAGS.includes(t));
                const review = reviews.results[i];

                const renderResponsiveTags = () => {
                  const responsiveTags = isBiggerThanMd ? tags : tags?.slice(0, 2);
                  return responsiveTags?.map((tag) => (
                    <ReviewTagChip key={`tag_${tag}_${i}`} tag={tag} />
                  ));
                };

                return (
                  <>
                    <HStack
                      key={`review_expand_${i}`}
                      gap={6}
                      maxWidth={isBiggerThanMd ? "100%" : "360px"}
                      overflow="scroll"
                    >
                      {renderResponsiveTags()}
                    </HStack>
                    <HStack
                      gap={6}
                      overflow="scroll"
                      margin="6px 0 0"
                      width="100%"
                      alignItems="end"
                      justifyContent="space-between"
                    >
                      <Box>
                        <StarScore score={review.score} />
                      </Box>
                      <Box className="caption_12_b warmGray700">
                        {dayjs(review.created_at).format("YYYY-MM-DD HH:mm")}
                      </Box>
                    </HStack>
                  </>
                );
              }}
              keys={
                isBiggerThanMd
                  ? [
                      {
                        text: "제목",
                        value: ["headline", "good"],
                        textAlign: "left",
                        renderCell: (v) => (
                          <Box css={titleCss(500)} className="subtitle_16_sb black">
                            {v}
                          </Box>
                        ),
                      },
                      {
                        text: "지역",
                        value: "district",
                        maxWidth: "120px",
                      },
                      {
                        text: "날짜",
                        value: "created_at",
                        maxWidth: "120px",
                        renderCell: (v) => <Box>{dayjs(v, "YYYY-MM-DD").format("YYYY-MM-DD")}</Box>,
                      },
                      {
                        text: "작성자",
                        value: "user",
                        renderCell: (v) => <Box>{v.nickname}</Box>,
                      },
                    ]
                  : [
                      {
                        text: "목록",
                        value: ["headline", "good"],
                        textAlign: "left",
                        renderCell: (v) => (
                          <Box css={titleCss(200)} className="subtitle_16_sb black">
                            {v}
                          </Box>
                        ),
                      },
                      {
                        text: "작성자",
                        value: "user",
                        renderCell: (v) => <Box>{v.nickname}</Box>,
                      },
                    ]
              }
              items={reviews.results}
              queryParams={router.query}
            />
          </>
        ) : (
          <ReviewSkeleton />
        )}
      </VStack> */}

      {/* <HStack padding="40px 0" justifyContent="center">
        <TablePagination
          totalCount={reviews?.count || 100}
          page={pageNum}
          limit={10}
          setPage={(page: number) => {
            customEvent({
              newGtm: { path: "review", trigger_and_target: "review_page-other_page" },
            });
            setReviewPageNum(page);
          }}
        />
      </HStack> */}
      {/* <TopBanner path="review_detail" /> */}
      {/** sadf */}
      {/* <VStack maxWidth="480px" margin="auto" width="100%"> */}
      {reviews ? (
        <VStack gap="12px">
          {reviews?.map((review) => (
            <ReviewCard
              key={review?.id}
              review={review}
              id={review?.id}
              currentTag={tag}
              event={{
                newGtm: { path: "review", trigger_and_target: "review-uv_review_detail" },
              }}
            />
          ))}
          {reviewsPages && hasNextPage && !isFetchingNextPage && (
            <div
              ref={setReviewTarget}
              css={{
                position: "absolute",
                bottom: "600px",
                width: "100%",
              }}
            />
          )}
        </VStack>
      ) : (
        <ReviewSkeleton />
      )}

      {/* </VStack> */}
    </MaxWidth1200Layout>
  );
}

export default ReviewContainer;

// const titleCss = (width: number) => {
//   return css({
//     display: "-webkit-box",
//     textOverflow: "ellipsis",
//     whiteSpace: "pre-line",
//     overflow: "hidden",
//     WebkitLineClamp: 2,
//     WebkitBoxOrient: "vertical",
//   });
// };

const ReviewFilter = () => {
  const { getReviewTagPageHref, tag: tagQueryParams } = useReviewPageRouter();

  return (
    <VStack padding="0px 24px 24px 24px">
      <h3 className="button_16_sb">비슷한 고민을 하셨던 상주님들의 후기를 살펴보세요</h3>
      <Spacing gap={15} />
      <HStack gap={6} maxWidth={"100%"} overflow="scroll">
        {["전체보기", ...SANGJO_REVIEW_TAGS].map((tagName) => {
          const isActived =
            tagName === tagQueryParams || (tagName === "전체보기" && !tagQueryParams);
          const href = getReviewTagPageHref(tagName === "전체보기" ? "" : tagName);

          return (
            <Link href={href} key={`filter_tag_${tagName}`}>
              <ReviewTagButtonChip tag={tagName} isActived={isActived} />
            </Link>
          );
        })}
      </HStack>
    </VStack>
  );
};

function ReviewSkeleton() {
  return (
    <VStack padding="0 24px">
      {/* <Gray50Skeleton h="28px" w="130px" /> */}
      {/* <VLine width="100%" height="2px" color={colors.gray300} /> */}
      {/* <Gray50Skeleton h="42px" w="100%" /> */}
      {/* <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" /> */}

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />

      <Spacing gap={28} />
      <SkeletonCircle size="48px" startColor="#F5F5F5" endColor="#E9E9E9" />
      <Gray50Skeleton h="30px" w="100%" mt="18px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Gray50Skeleton h="18px" w="100%" mt="12px" />
      <Spacing gap={28} />

      <VLine width="100%" height="1px" color={colors.gray100} />
      {/* <Gray50Skeleton h="36px" w="100%" mt="2px" /> */}

      {/* <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" />
      <Gray50Skeleton h="36px" w="100%" mt="2px" /> */}
    </VStack>
  );
}
